import { Pagination, RooftopAuthorizationCreateDto, PaginationQuery } from '@libs/dto';
import { RooftopAuthorizedEmployer } from '@libs/models';

import { api } from '../common.api';

export const rooftopAuthorizationApi = api.injectEndpoints({
  endpoints: (build) => ({
    rooftopAuthorizationCreate: build.mutation<RooftopAuthorizedEmployer, { rooftopId: string, body: RooftopAuthorizationCreateDto }>({
      query: ({ rooftopId, body }) => ({
        url: `/rooftop/${rooftopId}/authorization`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['RooftopAuthorization'],
    }),
    rooftopAuthorizationFindAll: build.query<Pagination<RooftopAuthorizedEmployer>, PaginationQuery & { id?: number }>({
      query: ({ id, q, page = 1, limit = 10 }) => ({
        url: `/rooftop/${id}/authorization`,
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['RooftopAuthorization'],
    }),
    rooftopAuthorizationDelete: build.mutation<void, { rooftopId: number, authorizationId: number }>({
      query: ({ rooftopId, authorizationId }) => ({
        url: `/rooftop/${rooftopId}/authorization/${authorizationId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['RooftopAuthorization'],
    }),
  }),
});

export const {
  useRooftopAuthorizationCreateMutation,
  useLazyRooftopAuthorizationFindAllQuery,
  useRooftopAuthorizationDeleteMutation,
} = rooftopAuthorizationApi;
